import React, { useEffect } from 'react'
import checkImage from '../../../assets/images/ico-check.svg'
import alertImage from '../../../assets/images/ico-alert.svg'
import './toast.scss'

const Toast = ({ className, message, activeToast, setActiveToast, check, onCloseEvent }) => {

    useEffect(() => {
        setTimeout(function () { setActiveToast(false) }, 3000)
    }, []);

    return (
        <div className="f-a-toast__container">
            <div className={"f-a-toast " + className + (activeToast ? "" : " __hidden")}>
                <img
                    src={check ? checkImage : alertImage}
                    alt="toast image"
                    loading="lazy"
                />
                <span>
                    {message ?
                        message
                        :
                        "Ha ocurrido un error,  por favor inténtelo de nuevo más tarde."
                    }
                </span>
                <div
                    className="f-a-toast__close"
                    onClick={() => {
                        { onCloseEvent && onCloseEvent() }
                        setActiveToast(false)
                    }}
                >
                    X
                </div>
            </div>
        </div>
    )
}

export default Toast
